export const MAX_NFT_NUMBER = 5;
export const HIDE_NFT_NUMBERS_FEATURE = false;
export const FREE_COUPON_ID = 'WELCOME0801';
export const BUTTON_FONT_SIZE_DESKTOP = '14px';
export const BUTTON_FONT_SIZE_MOBILE = '11px';
